import React from "react";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import { useState } from "react";

const ModalDelete = (props) => {
  return (
    <div>
      <Modal
        show={props.isShowWindow}
        onHide={props.onHide}
        size="lg"
        centered={true}
        backdrop={true}
      >
        <Modal.Body>
          <h4 className="mt-2 mb-4">{props.title}</h4>
        </Modal.Body>
        <Modal.Footer>
          <button
            className="large-button grey"
            onClick={props.onHide}
          >
            CLOSE
          </button>
          <button
            type="button"
            onClick={props.handleDelete}
            className="large-button red"
          >
            {props?.buttonTittle}
          </button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};
export default ModalDelete;
